export const BugFixLabel = () => {
  return (
    <div className="text-xs inline-flex font-medium bg-rose-100 dark:bg-rose-500/30 text-rose-500 dark:text-rose-400 rounded-full text-center px-2.5 py-1">
      Bug Fix
    </div>
  );
};
export const FeatureLabel = () => {
  return (
    <div className="text-xs inline-flex font-medium bg-emerald-100 dark:bg-emerald-400/30 text-emerald-600 dark:text-emerald-400 rounded-full text-center px-2.5 py-1">
      Feature
    </div>
  );
};
